// src/components/Header/headerConfig.ts
export const headerConfig: Record<string, {
  showSearch: boolean;
  gridClass: string;
  titleClass: string;
  extraRight?: "menu" | "imetanicLogo" | null;
}> = {
  Laundry: {
    showSearch: true,
    gridClass: "grid-container",
    titleClass: "font-bold text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl",
    extraRight: "menu",
  },
  Saloon: {
    showSearch: true,
    gridClass: "grid-container",
    titleClass: "font-bold text-xs sm:text-sm md:text-base lg:text-lg",
    extraRight: "menu",
  },
  Restaurant: {
    showSearch: true,
    gridClass: "grid-container",
    titleClass: "font-bold text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl",
    extraRight: "menu",
  },
  Carwash: {
    showSearch: false,
    gridClass: "car-grid-container",
    titleClass: "font-bold text-xs sm:text-sm md:text-base lg:text-lg",
    extraRight: "imetanicLogo",
  },
  "Car wash": {
    showSearch: false,
    gridClass: "car-grid-container",
    titleClass: "font-bold text-xs sm:text-sm md:text-base lg:text-lg",
    extraRight: "imetanicLogo",
  },
  "Vechicle retailer": {
    showSearch: false,
    gridClass: "grid-container",
    titleClass: "font-bold text-xs sm:text-sm md:text-base lg:text-lg",
    extraRight: "imetanicLogo",
  },
};